






































































import { GREEN, RED, YELLOW } from "@/resources/constants/busyReasons";
import { CHAT_TYPE } from "@/resources/constants/chat";
import { MEETING_TYPE } from "@/resources/constants/meeting";
import { Component, Emit, Vue } from "vue-property-decorator";
@Component({
  name: "chat-list-component",
})
export default class ChatListComponent extends Vue {
  loading = true;
  page = 1;
  lastPage = 1;
  openChats = [];
  search = "";
  lastScroll = 0;
  searchTimeOut = null;
  mounted() {
    this.getOpenChats();
    this.onScrollEvent();
  }
  get unSeeMessage() {
    return this.$store.getters["ChatStore/getUnSeenMessage"];
  }
  get listOpenChats() {
    const user = this.$store.getters["UserStore/getSpaceUser"];
    return this.openChats
      .filter((a) => {
        const fullName =
          a.superSpaceUser.user.name + a.superSpaceUser.user.lastName;
        return this.search !== ""
          ? fullName
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase()
              .includes(
                this.search
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
                  .toLowerCase()
              )
          : a;
      })
      .filter((a) => a.superSpaceUser.id !== user.superSpaceUser.id)
      .sort((a, b) =>
        this.unSeeMessage.filter(
          (unSee) =>
            unSee.type === CHAT_TYPE.ONE_TO_ONE &&
            unSee.id === a.superSpaceUser.id
        ).length > 0
          ? -1
          : 1
      );
  }
  get isRoomChatActive(): boolean {
    const meetingType = this.$store.getters["MeetingStore/getMeetingType"];
    const roomId = this.$store.getters["MeetingStore/getRoomId"];

    return (
      roomId !== 0 &&
      (this.$store.getters["SpaceStore/getSpace"].isWebinarChatActive ||
        meetingType !== MEETING_TYPE.WEBINAR) &&
      meetingType !== MEETING_TYPE.SPEED_NETWORKING
    );
  }
  onSearch(): void {
    if (this.listOpenChats.length < 5) {
      this.loading = true;
      const space = this.$store.getters["SpaceStore/getSpace"];
      if (this.searchTimeOut) clearTimeout(this.searchTimeOut);
      this.searchTimeOut = setTimeout(() => {
        this.$store.dispatch("ChatStore/getOpenChatsAction", {
          spaceId: space.id,
          page: 1,
          search: "&search=" + this.search,
          callback: (response) => {
            this.loading = false;
            const data = response.data.filter(
              (a) =>
                this.openChats.findIndex(
                  (b) => b.superSpaceUser.id === a.superSpaceUser.id
                ) < 0
            );
            this.openChats = [...this.openChats, ...data];
          },
        });
      }, 1000);
    }
  }
  getOpenChats(): void {
    const space = this.$store.getters["SpaceStore/getSpace"];
    if (this.page <= this.lastPage) {
      this.$store.dispatch("ChatStore/getOpenChatsAction", {
        spaceId: space.id,
        page: this.page,
        search: "",
        callback: (response) => {
          this.loading = false;
          this.openChats = [...this.openChats, ...response.data];
          this.page += 1;
          this.lastPage = response.headers["pagination-last-page"];
        },
        callbackError: (error) => {
          this.loading = false;
        },
      });
    } else {
      this.loading = false;
    }
  }
  openNewChat() {
    this.$store.dispatch("ChatStore/setMessagesAction", []);
    this.$store.dispatch("ChatStore/setNextTokenAction", null);
    this.$store.dispatch("ChatStore/setChatTypeAction", "");
    this.$emit("open-new-chat", true);
  }
  getShowUserUnSeenMessages(id) {
    return this.unSeeMessage.filter(
      (a) => a.type === CHAT_TYPE.ONE_TO_ONE && a.id === id
    ).length;
  }
  setAvatarColor(color: string): string {
    switch (color) {
      case GREEN.type:
        return GREEN.color;
      case RED.type:
        return RED.color;
      case YELLOW.type:
        return YELLOW.color;
      default:
        return RED.color;
    }
  }
  getRoomName(): string {
    return (
      this.$store.getters["MeetingStore/getRoomName"] ||
      this.$i18n.t("labels.chatNameDefault")
    );
  }

  async openUserChat(user): Promise<void> {
    await this.$store.dispatch("ChatStore/setMessagesAction", []);
    await this.$store.dispatch("ChatStore/setUserChatAction", {
      ...user.superSpaceUser,
      user: user.superSpaceUser.user,
    });
    await this.$store.dispatch(
      "ChatStore/setChatTypeAction",
      CHAT_TYPE.ONE_TO_ONE
    );
    await this.$store.dispatch("ChatStore/removeUnSeenMessageAction", {
      id: user.superSpaceUser.id,
      type: CHAT_TYPE.ONE_TO_ONE,
    });
    this.$emit("open-user-chat");
  }

  onScrollEvent() {
    const openChat = document.getElementById("open-chats-container");
    openChat.addEventListener("scroll", () => {
      const a = openChat.scrollTop;
      const b = openChat.scrollHeight - openChat.clientHeight;
      if (this.lastScroll < 0.6 && a / b > 0.6) {
        this.loading = true;
        this.getOpenChats();
        this.lastScroll = a / b;
      }
    });
  }
}
